export default "__VITE_ASSET__BtVqPV7n__"